import { graphql } from '~/gql'

export const GET_FACILITY_FLOOR_AND_VERSION_IDS = graphql(`
  query GetFacilityFloorAndVersionIds($facilityId: ID!) {
    Facility(id: $facilityId) {
      id
      floors {
        id
        versions {
          id
        }
      }
    }
  }
`)
